let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("g9I9R")]).then(() => parcelRequire('eKCAo'));